const commuRoutes = [
  {
    path: "/commu",
    name: "commu",
    meta: {
      title: "커뮤니티",
      titleEn: "Community",
      isDynamic: true,
    },
    children: [
      {
        path: "alert", // /commu/alert
        name: "saffAlertIndex",
        meta: {
          title: "알림톡",
          titleEn: "Alert",
          menuCd: "STAFF_COMM_ALERT",
          isDynamic: true,
        },
        children: [
          {
            path: "",
            meta: {
              title: "알림톡",
              titleEn: "Alert",
            },
            component: () => import("@/views/staff/commu/alert/StaffAlarmTalk.vue"),
          },
        ],
      },
      {
        path: "qna", // /commu/qna
        name: "staffQnaIndex",
        meta: {
          title: "Q&A",
          titleEn: "Q&A",
          menuCd: "STAFF_COMM_QNA",
          isDynamic: true,
        },
        children: [
          {
            path: "",
            meta: {
              title: "Q&A",
              titleEn: "Q&A",
            },
            component: () => import("@/views/staff/commu/qna/StaffQna.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "상세",
              titleEn: "Q&A Detail",
              isDynamic: true,
            },
            component: () => import("@/views/staff/commu/qna/StaffQnaDetail.vue"),
          },
          {
            path: "create",
            meta: {
              title: "등록",
              titleEn: "Q&A create",
              isDynamic: true,
            },
            component: () => import("@/views/staff/commu/qna/StaffQnaWrite.vue"),
          },
        ],
      },
      {
        path: "notice", // /commu/notice
        name: "staffNoticeIndex",
        meta: {
          title: "공지사항",
          titleEn: "Notice",
          menuCd: "STAFF_COMM_NOTICE",
          isDynamic: true,
        },
        children: [
          {
            path: "",
            meta: {
              title: "공지사항",
              titleEn: "Notice",
            },
            component: () => import("@/views/staff/commu/notice/StaffNotice.vue"),
          },
          {
            path: "detail",
            meta: {
              title: "공지사항",
              titleEn: "Notice Detail",
              isDynamic: true,
            },
            component: () => import("@/views/staff/commu/notice/StaffNoticeDetail.vue"),
          },
        ],
      },
      /** 공지사항 상세 */
    ],
  },
];

export default commuRoutes;
